export const EffectType = Object.freeze({
  ENTER: "enter",
  EXIT: "exit",
  LOOP: "loop",
  REST: "rest",
  TRANSITION: "transition"
});
